import Layout from '@/views/arena/Layout.vue';
const keepAlive = false;
/*
 * 如需使用动态import的分包特性，请注意优化分包规则和加载优化，避免打包出过多零散文件包
 * ps: 内网项目体积较小的情况下不太建议使用分包，分包过多反而容易打满浏览器并发连接数限制
 * webpackChunkName: 分包名,相同名称的包会被打包在一起,建议按分模块分包
 * webpackPrefetch: 页面加载完成后预取
 * webpackPreload: 页面加载时预加载
 */
// const List = () => import(/* webpackChunkName: 'List' */ /* webpackPrefetch :true */ /* webpackPreload :true */ '@/views/application/List.vue');

export default {
  path: '/llmArena/mobile',
  component: Layout,
  redirect: '/llmArena/mobile/home',
  children: [
    {
      path: '/llmArena/mobile/home',
      name: 'llmArena-mobileHome',
      component: () => import(/* webpackChunkName: 'Basic' */ '@/views/arena/mobile/MobileHome.vue'),
      meta: {
        icon: 'mtdicon mtdicon-home-o',
        title: '首页',
        cid: 'c_techportal_3p4z9q1k',
        keepAlive,
      },
    },
    {
      path: '/llmArena/mobile/history',
      name: 'llmArena-mobile-history',
      component: () => import(/* webpackChunkName: 'Basic' */ '@/views/arena/mobile/History.vue'),
      meta: {
        title: '学习历史',
        parent: '/llmArena/mobile/home',
      },
    },
    {
      path: '/llmArena/mobile/history/detail',
      name: 'llmArena-mobile-history-detail',
      component: () => import(/* webpackChunkName: 'Basic' */ '@/views/arena/mobile/HistoryDetail.vue'),
      meta: {
        title: '对话详情',
        parent: '/llmArena/mobile/history',
      },
    },
    {
      path: '/llmArena/mobile/tenMinQuiz',
      name: 'llmArena-mobile-tenMinQuiz',
      component: () => import(/* webpackChunkName: 'Basic' */ '@/views/arena/instance/eval/EvalIndex.vue'),
      meta: {
        title: '科普Quiz',
        parent: '/llmArena/mobile/home',
      },
    },
    {
      path: '/competition/activity/apply',
      name: 'competition-activity-apply',
      component: () => import(/* webpackChunkName: 'Basic' */ '@/views/mobile/ActivityApply.vue'),
      meta: {
        title: '活动报名',
        keepAlive,
      },
    },
  ],
};
